import * as React from 'react';

function PriceBoost(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 18" {...props}>
      <g clipPath="url(#prefix__clip0_3396_5447)">
        <path d="M17.869 18H0L3.131 0H21l-3.131 18z" fill="#00FFB7" />
        <path
          d="M12.59 2.862l-1.392 4.56 4.178 1.754-6.965 5.962 1.659-4.552L5.623 8.83l6.965-5.967z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_3396_5447">
          <path fill="white" d="M0 0h21v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PriceBoost;
